// The board game lobby's contract between words-happen-gql and the game app (WH-155): the invite link, and the error
// numbers the lobby refuses with. words-happen-service gives each refusal the code `<serviceCode>:<number>`; the app
// matches on the number, since the service code is the API's.

/** The number of each refusal in the lobby's error codes. */
export const GAME_LOBBY_ERROR_NUMBERS = {
  gameNotFound: '015',
  displayNameRequired: '017',
  tooManyGames: '018',
  invitationNotFound: '019',
  ownGame: '020',
  gameFull: '021',
  gameCancelled: '022',
  creatorDeleted: '023',
  notWaiting: '024',
} as const;

export type GameLobbyRefusalKind = keyof typeof GAME_LOBBY_ERROR_NUMBERS;

/** The lobby refusal an API error code is, whatever the service code; undefined for any other code. */
export const gameLobbyRefusalKind = (errorCode: string | undefined): GameLobbyRefusalKind | undefined =>
  (Object.keys(GAME_LOBBY_ERROR_NUMBERS) as GameLobbyRefusalKind[]).find((kind) =>
    errorCode?.endsWith(`:${GAME_LOBBY_ERROR_NUMBERS[kind]}`),
  );

/** Where an invite link lands in the game app. */
export const PLAY_JOIN_PATH = '/join';

/** The invite link's path for a code: the game app's invite landing page. */
export const joinGamePath = (code: string): string => `${PLAY_JOIN_PATH}/${encodeURIComponent(code)}`;

/** The invite link for a code, on the game app's origin, e.g. https://play.wordshappen.dev/join/7K3M9QXR. */
export const joinGameUrl = (playOrigin: string, code: string): string => new URL(joinGamePath(code), playOrigin).href;
